function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * trigger a callback based on an elements position in the viewport
 *
 * @param {String} selector - DOM element selector
 *
 * @param {String} settings.className - optional class to toggle on the element
 * @param {String} settings.threshold - px or %'age of viewport intersection
 * @param {Function} settings.onEnter - callback
 * @param {mixed} settings.onExit - callback see below
 *
 * @TODO find way to unobserve el after triggered once by passing onExit = {bool}
 * make that a default, to only run once and unobserve
 * onExit = callback or true to only run once
 */
var ViewportObserver = /*#__PURE__*/function () {
  function ViewportObserver(selector) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, ViewportObserver);

    this.elements = Array.from(document.querySelectorAll(selector));
    if (!this.elements || this.elements.length === 0) return;
    this.onExit = false;
    Object.assign(this, settings);
    this.createObserver();
  }

  _createClass(ViewportObserver, [{
    key: "createObserver",
    value: function createObserver() {
      var _this = this;

      var options = this.threshold ? {
        rootMargin: "0px 0px -".concat(this.threshold, " 0px")
      } : null;
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          return _this.handleIntersection(entry, observer);
        });
      }, options);
      this.elements.forEach(function (element) {
        return observer.observe(element);
      });
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entry, observer) {
      if (this.className) entry.target.classList.toggle(this.className, entry.isIntersecting);
      if (this.onEnter && entry.isIntersecting) this.onEnter(entry, observer);
      if (this.onExit && !entry.isIntersecting) this.onExit(entry, observer); // observer.unobserve(entry.target)
      // figure out a way to handle exit and handle once together
      // onExit doesn't really do what it sounds like right now
      // no way to track if it has already triggered.. :/
      // could attach to Node but no good way to handle multiple
      // observers if that were the case
      // console.log(observer)
    } // TODO test
    // may not be good attaching value to entry
    // should probably attach to nodeElement
    // https://stackoverflow.com/a/51976805/3026530

  }, {
    key: "updateDirection",
    value: function updateDirection(entry) {
      if (!entry.prevY || !entry.prevRatio) {
        entry.prevY = 0;
        entry.prevRatio = 0;
      }

      var currentY = entry.boundingClientRect.y;
      var currentRatio = entry.intersectionRatio;

      if (currentY < entry.prevY) {
        console.log('down');
        entry.scrollDir = "down";

        if (currentRatio > entry.prevRatio && entry.isIntersecting) {
          console.log('enter');
          entry.scrollState = "enter";
        } else {
          console.log('leave');
          entry.scrollState = "leave";
        }
      } else if (currentY > entry.prevY && entry.isIntersecting) {
        console.log('up');
        entry.scrollDir = "up";

        if (currentRatio < entry.prevRatio) {
          console.log('leave');
          entry.scrollState = "leave";
        } else {
          console.log('enter');
          entry.scrollState = "enter";
        }
      }

      entry.prevY = currentY;
      entry.prevRatio = currentRatio;
    }
  }]);

  return ViewportObserver;
}();

export { ViewportObserver as default };